import { render, staticRenderFns } from "./usecase.vue?vue&type=template&id=d20cc8f2&scoped=true&"
import script from "./usecase.vue?vue&type=script&lang=js&"
export * from "./usecase.vue?vue&type=script&lang=js&"
import style0 from "./usecase.vue?vue&type=style&index=0&id=d20cc8f2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20cc8f2",
  null
  
)

/* custom blocks */
import block0 from "./usecase.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports